<template>
	<popper
		class="omapi-has-tooltip"
		:class="conditionalClasses"
		:trigger="trigger"
		:force-show="forceShow"
		:tag-name="tagName"
		:disabled="disabled"
		:options="{
			placement,
			modifiers: {
				flip: {
					enabled: false,
				},
				preventOverflow: {
					escapeWithReference: true,
				},
			},
		}"
		:delay-on-mouse-over="delay"
		v-bind="$attrs"
		v-on="$listeners"
	>
		<div class="popper">
			<span v-if="tooltip">{{ tooltip }}</span>
			<slot name="tooltip" />
		</div>

		<slot slot="reference">
			<component :is="iconComponent" v-if="iconComponent" />
		</slot>
	</popper>
</template>

<script>
import Popper from 'vue-popperjs';
import 'vue-popperjs/dist/vue-popper.css';
export default {
	components: {
		popper: Popper,
	},
	inheritAttrs: false,
	props: {
		tooltip: {
			type: String,
			default: '',
		},
		placement: {
			type: String,
			default() {
				return 'top';
			},
		},
		trigger: {
			type: String,
			default() {
				return 'hover';
			},
		},
		forceShow: {
			type: Boolean,
			default() {
				return false;
			},
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		tagName: {
			type: String,
			default: 'span',
		},
		delayOnMouseOver: {
			type: Number,
			default: 500,
		},
		icon: {
			type: [String, Boolean],
			default() {
				return 'default-help';
			},
		},
	},
	computed: {
		iconComponent() {
			return this.icon && 'default-help' !== this.icon ? this.icon : false;
		},
		delay() {
			if (500 !== this.delayOnMouseOver) {
				return this.delayOnMouseOver;
			}

			return this.iconComponent && !this.$get('$slots.default') ? 100 : this.delayOnMouseOver;
		},
		conditionalClasses() {
			let classes = [];

			if (!this.icon || 'default-help' !== this.icon) {
				classes.push('omapi-has-tooltip__no-icon');
			}

			return classes.join(' ');
		},
	},
};
</script>
